import React from "react";
import DealFactorItems from "./DealFactorItems";
import { Button, Col, FormGroup, Input, Row } from "reactstrap";
import { TbArrowBigLeft, TbArrowBigRight } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { IoMdAddCircle } from "react-icons/io";
import {
  setInvoiceItemsToDisplay,
  setNewItemsToDisplay,
} from "../../../../redux/slices/MsgSlice";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

const DealFactorTitle = ({
  itemsToDisplay,
  sliceSize,
  handlePrevious,
  currentIndex,
  options,
  newItems,
  selectedPackages,
  handleInputChange,
  handlePackageSelection,
  handleAddItemToPackages,
  handleDealFactorItemDeletion,
  setModal,
  handleNext,
  setItemsToDisplay,
  state,
  checked,
  setCurrentIndex,
}) => {
  const dispatch = useDispatch();

  const handleDeleteItem = (index) => {
    const actualIndex = currentIndex + index;
    const updatedItems = itemsToDisplay.filter((_, i) => i !== actualIndex);

    // Dispatch the updated list
    if (state?.invoice) {
      if (checked) {
        dispatch(setNewItemsToDisplay(updatedItems));
      } else {
        dispatch(setInvoiceItemsToDisplay(updatedItems));
      }
    } else {
      dispatch(setItemsToDisplay(updatedItems));
    }

    // Recalculate valid currentIndex
    const maxPossibleIndex = Math.max(0, updatedItems.length - sliceSize);
    let newIndex = currentIndex;

    if (actualIndex < currentIndex) {
      // Deleted something before the current view → shift left
      newIndex = currentIndex - 1;
    } else if (actualIndex >= currentIndex + sliceSize) {
      // Deleted something after current view → no change needed
    } else {
      // Deleted inside current view → may need to shift left to avoid empty
      if (currentIndex > maxPossibleIndex) {
        newIndex = maxPossibleIndex;
      }
    }

    // Ensure we never go below 0 or beyond max
    newIndex = Math.max(0, Math.min(newIndex, maxPossibleIndex));

    setCurrentIndex(newIndex);

    // Special case: if no items left, reset index
    if (updatedItems.length === 0) {
      setCurrentIndex(0);
    }
  };
  console.log(itemsToDisplay, "itemsToDisplay");
  return (
    <div className="deal-factor-container">
      {itemsToDisplay?.length > sliceSize && (
        <div
          className="deal-factor-nav-arrow"
          onClick={handlePrevious}
          disabled={currentIndex === 0}
        >
          <ArrowLeft size={35} />
        </div>
      )}
      <div className="deal-factor-row">
        {itemsToDisplay?.length > 0 ? (
          <>
            {itemsToDisplay
              .slice(currentIndex, currentIndex + sliceSize)
              .map((item, index) => (
                <Col
                  key={index}
                  className="deal-factor-column"
                  style={{ animationDelay: `${index * 0.06}s` }}
                >
                  <div className="deal-factor-card">
                    <FormGroup>
                      <Input
                        type="select"
                        className="deal-factor-select"
                        value={item.type}
                        onChange={(e) => {
                          const updatedItems = [...itemsToDisplay];
                          updatedItems[index + currentIndex] = {
                            ...updatedItems[index + currentIndex],
                            type: e.target.value,
                          };
                          dispatch(setItemsToDisplay(updatedItems));
                        }}
                      >
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <DealFactorItems
                      item={item}
                      newItems={newItems}
                      selectedPackages={selectedPackages}
                      handleInputChange={handleInputChange}
                      handlePackageSelection={handlePackageSelection}
                      handleAddItemToPackages={handleAddItemToPackages}
                      handleDealFactorItemDeletion={
                        handleDealFactorItemDeletion
                      }
                      state={state}
                      checked={checked}
                    />
                    <div className="text-center">
                      <button
                        className="deal-factor-delete-button "
                        onClick={() => handleDeleteItem(index)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
          </>
        ) : (
          <div className="deal-factor-empty-state">
            <Button
              className="deal-factor-add-button"
              onClick={() => setModal(true)}
            >
              <IoMdAddCircle size={18} />
              <span>Add New Deal Factor</span>
            </Button>
          </div>
        )}
      </div>
      {itemsToDisplay?.length > sliceSize && (
        <div
          className="deal-factor-nav-arrow"
          onClick={() => handleNext(itemsToDisplay?.length)}
          disabled={currentIndex + sliceSize >= itemsToDisplay.length}
        >
          <ArrowRight size={35} />
        </div>
      )}
    </div>
  );
};

export default DealFactorTitle;
